module.exports = __webpack_public_path__ + "static/media/Risk Management Report Summary.4de92d16.pdf";